module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exceed":"You have exceeded the number of interviews in your plan","variants":"You can","leftDays":"Days left","wait":"Wait for the next period to start","choose":"Choose plan","upgrade":"Upgrade your plan and see new applicants right now."}}')
  delete Component.options._Ctor
}
